import { render } from "./accountPlanModel.vue?vue&type=template&id=a9dd354a"
import script from "./accountPlanModel.vue?vue&type=script&lang=js"
export * from "./accountPlanModel.vue?vue&type=script&lang=js"

import "./accountPlanModel.vue?vue&type=style&index=0&id=a9dd354a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__